var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckSmallOutline(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.95325 14.6465C7.84214 14.6465 7.73797 14.6291 7.64075 14.5944C7.54353 14.5597 7.45325 14.5007 7.36992 14.4173L3.78659 10.834C3.63381 10.6812 3.56089 10.4833 3.56784 10.2402C3.57478 9.99718 3.65464 9.79926 3.80742 9.64648C3.9602 9.49371 4.15464 9.41732 4.39075 9.41732C4.62686 9.41732 4.82131 9.49371 4.97409 9.64648L7.95325 12.6257L15.0158 5.56315C15.1685 5.41037 15.3664 5.33398 15.6095 5.33398C15.8526 5.33398 16.0505 5.41037 16.2033 5.56315C16.356 5.71593 16.4324 5.91385 16.4324 6.1569C16.4324 6.39996 16.356 6.59787 16.2033 6.75065L8.53659 14.4173C8.45325 14.5007 8.36297 14.5597 8.26575 14.5944C8.16853 14.6291 8.06436 14.6465 7.95325 14.6465Z",
    fill: "#074E9F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckSmallOutline);
export default __webpack_public_path__ + "static/media/CheckSmallOutline.f34001233d50bb5dcd8ce8c6da3b498e.svg";
export { ForwardRef as ReactComponent };